/**
 * Особая отметка премии или штрафа в расчётке (26.10.2026, владелец: «в премиях и штрафах добавь возможность
 * начислить их тихо, без уведомлений, а так же возможность это добавление как-то особо отмечать в расчётке»).
 * Одни правила для сервера (bonuses/penalties.slip_mark, зарплата, TG-расчётка) и приложения (выдача, лента HR,
 * кабинет оператора, «Зарплаты», картинка расчётки).
 *
 * slip_mark: NULL — без отметки; строка — отметка с подписью («KPI сентябрь»); «★» — отметка без подписи.
 */

/** Отметка без подписи — так хранится, когда подпись не дали. */
export const SLIP_MARK_PLAIN = "★";
/** Подпись отметки — коротко: она стоит плашкой в строке расчётки. */
export const SLIP_MARK_MAX = 40;

/**
 * Ввод (тело запроса, форма) → значение колонки. true или пустая подпись — «★»; строка — подпись без переводов строк,
 * ≤ SLIP_MARK_MAX; false/null/"" — снять отметку (null). undefined — поля нет: не трогать (undefined).
 */
export function normSlipMark(v: unknown): string | null | undefined {
  if (v === undefined) return undefined;
  if (v === true) return SLIP_MARK_PLAIN;
  if (typeof v !== "string") return null;
  const s = v.replace(/[\u0000-\u001f\u007f]+/g, " ").replace(/\s+/g, " ").trim().slice(0, SLIP_MARK_MAX).trim();
  return s ? s : null;
}

/** Есть ли отметка у строки (значение колонки или поле mark из зарплаты). */
export const hasSlipMark = (m: unknown): m is string => typeof m === "string" && m.trim().length > 0;

/** Подпись для показа: «» у отметки без подписи (тогда показывают одну звезду). */
export const slipMarkLabel = (m: unknown): string => (hasSlipMark(m) && m.trim() !== SLIP_MARK_PLAIN ? m.trim() : "");

/** «★» или «★ KPI сентябрь» — для текста (TG, ленты, строки зарплаты). Пусто, если отметки нет. */
export function slipMarkText(m: unknown): string {
  if (!hasSlipMark(m)) return "";
  const l = slipMarkLabel(m);
  return l ? `${SLIP_MARK_PLAIN} ${l}` : SLIP_MARK_PLAIN;
}
